//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { PrimaryAnchor } from '@components/atoms/anchor/Anchor';
import {
  DM_PERMISSION_SETUP_GUIDE_URL,
  UIA_RIGHTS_FLOW_TRACKING_IDS,
} from '@uia/rights/constants/uiaRightsConstants';

export interface DmRightsRequestSetupGuideLinkProps {
  text: string;
}

export const DmRightsRequestSetupGuideLink = ({
  text,
}: DmRightsRequestSetupGuideLinkProps) => {
  return (
    <PrimaryAnchor
      href={DM_PERMISSION_SETUP_GUIDE_URL}
      target='_blank'
      trackingId={UIA_RIGHTS_FLOW_TRACKING_IDS.DM_PERMISSION_SETUP_GUIDE_LINK}
    >
      {text}
    </PrimaryAnchor>
  );
};
